import React, { Fragment } from 'react'

const Footer = () => {
   return (
      <Fragment>
         <p className="copy">
            &copy; Desarrollado por Sebaavt95
         </p>
      </Fragment>
   );
}

export default Footer;